import {HttpClient, HttpResponse} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {ENVIRONMENT, EnvironmentShared, Fna} from '@emma-labs/shared/typescript';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {defaultOptions, handleHttpError, responseToObject} from '../http-utils';

@Injectable({
  providedIn: 'root',
})
export class FnaApiService {
  private readonly basePath: string;

  constructor(
    private readonly http: HttpClient,
    @Inject(ENVIRONMENT) private readonly environment: EnvironmentShared,
  ) {
    this.basePath = `${this.environment.msFnaApiBase}/fnas`;
  }

  getByCurrentSessionHolder(sessionId: string): Observable<Fna> {
    const options = defaultOptions(sessionId, {appName: this.environment.app}).buildOptions();
    const url = new URL(`${this.basePath}/me`);

    return this.http.get(url.toString(), options).pipe(
      map((response) => responseToObject<Fna>(response as HttpResponse<string>)),
      catchError(handleHttpError),
    );
  }

  getById(sessionId: string, fnaId: string): Observable<Fna> {
    const options = defaultOptions(sessionId, {appName: this.environment.app}).buildOptions();
    const url = new URL(`${this.basePath}/${btoa(fnaId)}`);

    return this.http.get(url.toString(), options).pipe(
      map((response) => responseToObject<Fna>(response as HttpResponse<string>)),
      catchError(handleHttpError),
    );
  }

  create(sessionId: string, fna: Fna): Observable<Fna> {
    const options = defaultOptions(sessionId, {appName: this.environment.app}).buildOptions();
    const url = new URL(`${this.basePath}`);

    return this.http.post(url.toString(), fna, options).pipe(
      map((response) => responseToObject<Fna>(response as HttpResponse<string>)),
      catchError(handleHttpError),
    );
  }

  update(sessionId: string, fnaId: string, fna: Fna): Observable<Fna> {
    const options = defaultOptions(sessionId, {appName: this.environment.app}).buildOptions();
    const url = new URL(`${this.basePath}/${btoa(fnaId)}`);

    return this.http.put(url.toString(), fna, options).pipe(
      map((response) => responseToObject<Fna>(response as HttpResponse<string>)),
      catchError(handleHttpError),
    );
  }

  delete(sessionId: string, fnaId: string): Observable<void> {
    const options = defaultOptions(sessionId, {appName: this.environment.app}).buildOptions();
    const url = new URL(`${this.basePath}/${btoa(fnaId)}`);

    return this.http.delete(url.toString(), options).pipe(
      map(() => undefined),
      catchError(handleHttpError),
    );
  }
}
